import WhiteLogo from "./WhiteLogo";

export default WhiteLogo;
